<div class="regime-modal">
  <header class="regime-modal__header">
    <div class="regime-modal__title-row">
      <h2 class="regime-modal__title">{{ texts.title }}</h2>
      <ds-icon-button-v2
        emphasis="secondary-filled"
        size="s"
        icon="Close"
        [ariaLabel]="texts.closeLabel"
        (clicked)="closeModal()"
      ></ds-icon-button-v2>
    </div>

    <ds-tabs
      size="s"
      [tabs]="tabOptions"
      [value]="activeTab"
      (valueChange)="showTab($event)"
    ></ds-tabs>
  </header>

  <div class="regime-modal__body">
    <section class="regime-modal__section">
      <h3 class="regime-modal__subtitle">{{ texts.intro }}</h3>

      <ul class="regime-modal__list">
        <li *ngFor="let bullet of activeContent.bullets" class="regime-modal__list-item">
          {{ bullet }}
        </li>
      </ul>
    </section>

    <div class="regime-modal__highlight">
      <span class="regime-modal__highlight-icon" aria-hidden="true">
        <svg viewBox="0 0 960 960">
          <path
            d="M336,840Q245,840 182.5,777.5Q120,715 120,624Q120,586 133,550Q146,514 170,485L312,314L244,178Q234,158 245.5,139Q257,120 280,120L680,120Q703,120 714.5,139Q726,158 716,178L648,314L790,485Q814,514 827,550Q840,586 840,624Q840,715 777,777.5Q714,840 624,840L336,840ZM480,640Q447,640 423.5,616.5Q400,593 400,560Q400,527 423.5,503.5Q447,480 480,480Q513,480 536.5,503.5Q560,527 560,560Q560,593 536.5,616.5Q513,640 480,640ZM385,280L575,280L615,200Q615,200 615,200Q615,200 615,200L345,200Q345,200 345,200Q345,200 345,200L385,280ZM336,760L624,760Q681,760 720.5,720.5Q760,681 760,624Q760,600 751.5,577.5Q743,555 728,537L581,360L380,360L232,536Q217,554 208.5,577Q200,600 200,624Q200,681 239.5,720.5Q279,760 336,760Z"
            fill="currentColor"
          />
        </svg>
      </span>
      <p class="regime-modal__highlight-text">
        <ng-container *ngFor="let part of activeContent.highlight">
          <strong *ngIf="part.strong">{{ part.text }}</strong>
          <ng-container *ngIf="!part.strong">{{ part.text }}</ng-container>
        </ng-container>
      </p>
    </div>

    <ds-inline-alert
      type="info"
      size="s"
      [description]="activeContent.note"
    ></ds-inline-alert>
  </div>
</div>
